import { render } from "./HistoryFlowTrigger.vue?vue&type=template&id=8714cbac"
import script from "./HistoryFlowTrigger.vue?vue&type=script&lang=js"
export * from "./HistoryFlowTrigger.vue?vue&type=script&lang=js"
script.render = render

export default script